"use client";
import { access } from "@/app/lib/roles";
import { Session } from "@/app/interfaces/session";

import {
  DropdownItem,
  DropdownTrigger,
  Dropdown,
  DropdownMenu,
  User,
} from "@heroui/react";
import { signOut } from "next-auth/react";

const UserDropdown = ({
  session,
  fPanelAccess,
  fractionId,
}: {
  session: Session;
  fPanelAccess?: boolean;
  fractionId?: boolean;
}) => {
  return (
    <Dropdown placement="bottom-end">
      <DropdownTrigger>
        <User
          as="button"
          avatarProps={{
            isBordered: true,
            src: session?.user?.image as string,
          }}
          className="transition-transform"
          description={
            (session?.user?.role as string) === "USER"
              ? "Gracz"
              : session?.user?.role
          }
          name={session?.user?.name as string}
        />
      </DropdownTrigger>
      <DropdownMenu aria-label="Profile Actions" variant="flat">
        <DropdownItem key="myprofile" href="/profile">
          Mój profil
        </DropdownItem>
        {access.adminPanel.includes(session?.user?.role as string) ? (
          <DropdownItem key="adminpanel" href="/adminpanel">
            Panel Admina
          </DropdownItem>
        ) : null}
        {(fPanelAccess && session?.user.role === "FRACTION") ||
        access.fractions.includes(session?.user.role as string) ? (
          <DropdownItem
            key="adminpanel-d"
            href={
              access.fractions.includes(session?.user.role as string)
                ? `/fractionspanel`
                : `/fractionspanel/${fractionId}`
            }>
            Panel frakcji
          </DropdownItem>
        ) : null}
        <DropdownItem
          key="logout"
          href="#"
          color="danger"
          onPress={() => signOut({ redirect: true, callbackUrl: "/" })}>
          Wyloguj
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
};

export default UserDropdown;
